<template>
    <div>
        <p v-if="list.title" class="box-title">{{list.title}}</p>
        <component :is="viewMode ? 'div' : 'form'" class="form">
            <field-group :view-mode="viewMode" v-for="(group,index) in list.groups" :group="group" :answers="getAnswers(group)" :key="group.id" :idGroup="index"></field-group>
        </component>
    </div>
</template>

<script>
    import FieldGroup from "./FieldsGroup";

    export default {
        name: 'questionnaire-list',
        components: {FieldGroup},
        props: {
            list: Object,
            answers: Array,
            viewMode: Boolean
        },
        methods: {
            getAnswers(group) {
                const questions = group.questions;
                let groupAnswers = [];
                questions.forEach((item) => {
                    let ans = this.answers.find(x => x.questionId === item.id);
                    ans = ans ? ans : '';
                    groupAnswers.push(ans)
                });
                return groupAnswers;
            }
        },
        created() {

        }
    }
</script>


<style scoped>

</style>
